<!-- 油卡管理 -->
<template>
    <div>
        <template v-if="!isInitialized">
            <div class="block-container">
                <van-empty description="正在读取中..."/>
            </div>
        </template>
        <template v-if="!cardList.length && isInitialized">
            <div class="block-container">
                <van-empty description="暂无卡片"/>
            </div>
        </template>
        <template v-if="cardList.length && isInitialized">
            <div class="card-list-container">
                <div v-for="(item, index) in cardList" :key="'card'+index" class="card-container card-selected">
                    <card-design :card-info="item"/>
                    <van-row class="card-menu">
                        <van-col :span="8" class="card-option after-divider" @click="item.is_add_my_card ? false : bindCard(item.open_id)">
                            <span v-if="item.is_add_my_card" style="color: #999">此卡已绑定</span>
                            <span v-else>添加到卡片</span>
                        </van-col>
                        <van-col :span="8" class="card-option after-divider" @click="startUserList(item.open_id)">
                            <span>人员管理</span>
                        </van-col>
                        <van-col :span="8" class="card-option" @click="shareCard(item.open_id)">
                            <span>邀请加入</span>
                        </van-col>
                    </van-row>
                    <van-row class="card-menu">
                        <van-col :span="8" class="card-option after-divider" @click="$router.push({ name : 'CompanyCardConsumeLog', query: { open_id: item.open_id, user_company_auth_id : companyId}})">
                            <span>消费记录</span>
                        </van-col>
                        <van-col :span="8" class="card-option" @click="$router.push({ name : 'CompanyCardIntegralLog', query: { open_id: item.open_id, user_company_auth_id : companyId}})">
                            <span>积分记录</span>
                        </van-col>
                    </van-row>
                </div>
            </div>
        </template>
        <van-popup v-model="userListSwitch" round position="bottom">
            <div class="user-list-title">
                <span>用户列表</span>
            </div>
            <van-cell-group class="user-list-content">
                <van-cell title="item" value="item" v-for="(item, index) in userList" :key="'user'+index">
                    <template #title>
                        <div class="user-info">
                            <van-image
                                width="45"
                                height="45"
                                :src="item.user_info.avatar"/>
                            <span class="user-name">{{item.user_info.nickname}}</span>
                        </div>
                    </template>
                    <template>
                        <div class="user-option">
                            <van-button type="danger" size="normal" :loading="item.loading" @click="unbindCard(item.id, index)">解绑</van-button>
                        </div>
                    </template>
                </van-cell>
            </van-cell-group>
        </van-popup>
    </div>
</template>

<script>
    import api from '../../assets/js/api'
    import cardDesign from '../../components/beilin/CardDesign.vue'
    import wx from 'weixin-js-sdk'
    export default {
        name: 'CompanyCardList',
        components: {cardDesign},
        data () {
            return {
                loading: false,
                isInitialized: false,
                userListSwitch: false,
                userList: [],
                cardList: [],
                cardSelected: 'card0',
                companyId: this.$route.query.user_company_auth_id,
                shareMessage: {}
            }
        },
        created() {
            api.request('/company_card/list', {
                user_company_auth_id: this.$route.query.user_company_auth_id
            }).then(res => {
                this.cardList = res.data;
                this.isInitialized = true;
            })
        },
        methods: {
            refresh() {
                let self = this;
                api.request('/company_card/list', {
                    user_company_auth_id: this.$route.query.user_company_auth_id
                }).then(res => {
                    self.cardList = res.data;
                    self.loading = false;
                })
            },
            bindCard(openId) {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/company_card/add_my_card', {
                    user_company_auth_id: this.companyId,
                    open_id: openId
                }).then(res => {
                    self.$toast.clear(toast);
                    self.$toast.success(res.msg);
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.refresh();
                })
            },
            unbindCard(id, index) {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '解绑中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/company_card/unbind_card', {
                    user_company_auth_id: this.companyId,
                    card_id: id
                }).then(res => {
                    self.userList.splice(index, 1)
                    self.$toast.clear(toast);
                    self.$toast.success(res.msg);
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.refresh();
                })
            },
            startUserList(openId) {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                this.userList = [];
                let toast = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/company_card/bind_card_user', {
                    user_company_auth_id: this.companyId,
                    open_id: openId
                }).then(res => {
                    self.$toast.clear(true);
                    self.userList = res.data;
                    self.userListSwitch = true;
                }).catch(res => {
                    self.$toast.clear(true);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            },
            shareCard(openId) {
                if (this.loading) return false;
                let self = this;
                this.loading = true;
                let toast = this.$toast.loading({
                    message: '正在生成邀请链接',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                api.request('/company_card/get_use_card_invite', {
                    user_company_auth_id: this.companyId,
                    open_id: openId
                }).then(res => {
                    self.shareMessage = res.data;
                    self.$toast.clear(toast);
                    self.$dialog.alert({
                        message: '邀请信息生成成功，请点击右上角选择“发送给朋友”进行邀请',
                    });
                    wx.updateAppMessageShareData({ 
                        title: '邀请加入',
                        desc: '邀请绑定公司卡',
                        link: `${window.location.origin}/${self.$route.params.companyId}/company/company_card_invite?id=${res.data.id}`,
                        imgUrl: self.inviteImg
                    });
                    console.log(`${window.location.origin}/${self.$route.params.companyId}/company/company_card_invite?id=${res.data.id}`)
                }).catch(res => {
                    self.$toast.clear(toast);
                    self.$toast.fail(res.msg);
                }).finally(() => {
                    self.loading = false;
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .block-container {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        background: #fff;

        .van-empty {
            padding-top: 0;
        }
    }

    .card-list-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        background: #f2f2f2;

        .card-container {
            margin: 0.3rem 0 0.3rem 0;
        }

        .card-selected {
            padding: 0.1rem 0.4rem;
            border: 2px solid #f8f8f8;
            background-color: #fff;
            border-radius: 0.5rem;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
        }

        .card-menu {
            .card-option {
                display: flex;
                align-items: center;
                justify-content: center;
                color: #333;
                margin: 0;
                span {
                    width: 100%;
                    text-align: center;
                    padding: 10px;
                    display: inline-block;
                    animation: .5s fade-in;
                }
            }
            .after-divider {
                &::after {
                    content: '|'
                }
            }
        }

        @keyframes fade-in {
            0% {
                font-size: 1px;
            }
            50% { 
                font-size: 12px;
            }
            100% { 
                font-size: 14px;
            }
        }
    }

    .user-list-title {
        width: 100%;
        height: 1.5rem;
        border: 1px solid #ddd;
        span {
            line-height: 1.5rem;
            display: block;
            text-align: center;
            color: #999;
            font-size: 16px;
        }
    }
    .user-list-content {
        height: 80vh;
        overflow-y: auto;
        .user-info {
            display: flex;
            justify-content: start;
            align-items: center;
            .user-name {
                font-size: 14px;
                color: #666;
                margin-left: 15px;
            }
        }
        .user-option {
            display: flex;
            justify-content: flex-end;
            align-items: center;
        }
    }

</style>


// WEBPACK FOOTER //
// src/pages/company/companyCardList.vue